
import React from 'react';
import SwipePreview from '../SwipePreview';

const ExperienceSection: React.FC = () => {
  return (
    <section className="pt-24 pb-32 relative overflow-visible">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in-subtle">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Swipe Your Way <span className="text-pink-400">Home</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Experience our intuitive swiper just like on the discover page. Try swiping through these sample properties to get a feel for how easy it is to find your perfect home.
          </p>
        </div>
        
        <div className="flex justify-center">
          <SwipePreview />
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
